import React, { FC } from 'react';
import { Formik, Form } from 'formik';
import COButton from 'shared/components/COButton';
import { ButtonLabels } from 'enums/COPopoverEnums';
import {
  baselineYearList,
  initialReportingValues,
  monthList,
  ReportValues,
} from '../../companySetupConstants';
import COSelect from 'shared/components/COSelect';
import InputField from 'shared/components/InputField';
import styles from '../../organisation.module.scss';
import { reportingValidationSchema } from '../../validation';
import {
  ReportingFieldLabels,
  ReportingFieldNames,
  ReportingFieldPlaceholders,
} from 'enums/ReportingDetailsEnums';
import { allowOnlyPercentages } from 'shared/utils/convertFormData';
import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
interface ReportingDetailsFormProps {
  handleSubmit: (values: ReportValues) => void;
  handleBackToOrgDetails: () => void;
  handleToolTipOpen?: (fieldName?: HelpDeskInputFieldEnum) => () => void;
}

const ReportingDetailsForm: FC<ReportingDetailsFormProps> = ({
  handleSubmit,
  handleBackToOrgDetails,
  handleToolTipOpen,
}) => {
  const {
    reportingDetailsYear,
    reportingDetailsBaselineYear,
    reportingDetailsThreshold,
  } = HelpDeskInputFieldEnum;
  return (
    <Formik
      initialValues={initialReportingValues}
      validationSchema={reportingValidationSchema}
      onSubmit={handleSubmit}>
      {() => (
        <Form>
          <div className={styles.reportFormWrapper}>
            <div className={styles.fieldContainer}>
              <COSelect
                allowClear={false}
                name={ReportingFieldNames.START_OF_REPORTING_YEAR}
                label={ReportingFieldLabels.START_OF_REPORTING_YEAR}
                placeholderstring={
                  ReportingFieldPlaceholders.START_OF_REPORTING_YEAR
                }
                options={monthList}
                info
                infoClick={handleToolTipOpen?.(reportingDetailsYear)}
              />
            </div>
            <div className={styles.fieldContainer}>
              <COSelect
                allowClear={false}
                name={ReportingFieldNames.BASELINE_YEAR}
                label={ReportingFieldLabels.BASELINE_YEAR}
                placeholderstring={ReportingFieldPlaceholders.BASELINE_YEAR}
                options={baselineYearList}
                info
                infoClick={handleToolTipOpen?.(reportingDetailsBaselineYear)}
              />
            </div>
            <div className={styles.fieldContainer}>
              <InputField
                name={ReportingFieldNames.RECALCULATION_THRESHOLD}
                onKeyDown={allowOnlyPercentages}
                maxLength={5}
                label={ReportingFieldLabels.RECALCULATION_THRESHOLD}
                placeholderstring={
                  ReportingFieldPlaceholders.RECALCULATION_THRESHOLD
                }
                info
                infoClick={handleToolTipOpen?.(reportingDetailsThreshold)}
              />
            </div>
          </div>
          <div className={styles.buttonReportContainer}>
            <COButton submit>{ButtonLabels.SAVE_AND_PROCEED}</COButton>
            <COButton secondary onClick={handleBackToOrgDetails}>
              {ButtonLabels.BACK}
            </COButton>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ReportingDetailsForm;
